<template>
  <div class='wrapper'>
    <div class="demo"></div>
    <div class="demo1"></div>
  </div>
</template>

<script>
export default {
  props: {
    time: Number
  },
  data() {
    return {}
  },
  computed: {},
  methods: {},
  created() {},
  mounted() {
    require('./js/jquery-1.11.0.min.js')
    require('./js/jquery.fireworks.js')
    $('.demo').fireworks({
      sound: true,
      opacity: 0.6,
      width: '100%',
      height: '100%',
      time: this.time,
    })
    $('.demo1').fireworks({
      sound: true,
      opacity: 0.6,
      width: '100%',
      height: '100%',
      time: this.time,
    })
  },
  updated() {},
  watch: {},
}
</script>

<style lang='scss' scoped>
// @import './css/normalize.css';
// @import './css/demo.css';
</style>